import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/baseUi/tooltip"
import { cn } from "@/modules/lib/utils"
import { shortenText } from "@/modules/utils/stringUtils"
import { NoteEmptyIcon } from "@images/svgIcons/essentials/noteEmptyIcon"
import { NoteIcon } from "@images/svgIcons/essentials/noteIcon"
import { Text } from "@/components/ui/baseUi/text"

export type HuNoteProps = {
  index: string
  note: string
  className?: string
} & React.ComponentProps<"div">

function HuNote({ note = "", className, ...props }: HuNoteProps) {
  return (
    <div className={cn(className)} {...props}>
      {note ? (
        <Tooltip>
          <TooltipTrigger render={<NoteIcon size={16} color="currentColor" className="text-textDefault-body" />} />
          <TooltipContent side="bottom" className="w-fit max-w-60 wrap-break-word whitespace-normal">
            <Text fontStyle="BM">{shortenText(note, 250)}</Text>
          </TooltipContent>
        </Tooltip>
      ) : (
        <NoteEmptyIcon size={16} color="currentColor" className="text-textDefault-body" />
      )}
    </div>
  )
}

HuNote.displayName = "HuNote"
export { HuNote }
